import React from 'react';
import './style.scss';
import { Spin } from 'antd';
import { formatAmount } from '@share/utils';
import { FormattedMessage } from 'react-intl';


interface BankDetails {
  bankName: string;
  lastFourDigits: string;
  bankType: string;
}

interface CreditLineInvoiceDetail {
  creditLineInvoiceDetailId: number;
  bookingId: number;
  paid: boolean;
  paidDate: string;
  amount: number;
}

interface CreditLineInvoicesType {
  creditLineInvoiceId: number;
  created: string;
  amount: number;
  urlPdf: string;
  dueDate: string;
  comments: string;
  paymentStatus: string;
  paidDate: string;
  accountName: string;
  creditLineInvoiceDetails: CreditLineInvoiceDetail[];
}
interface CompanyPlaidComponentProps {
  creditLineInvoices: CreditLineInvoicesType;
  bankName: BankDetails[];
  selectedBank: {} | null;
  isBankLoading: boolean;
  amount: number;
  handleProceed: () => void;
  handleBankSelection: (e: React.ChangeEvent<HTMLInputElement>, bank: any) => void;
}

const CompanyIndividualPlaidPaymentComponent: React.FC<CompanyPlaidComponentProps> = ({
  bankName,
  selectedBank,
  handleProceed,
  handleBankSelection,
  isBankLoading,
  amount
}) => {
  return (
    <>
      <Spin spinning={isBankLoading} className="d-flex align-items-center justify-content-center">
        <div className="accountDetail">
          <div className="accountDetail_payment d-flex align-items-center w-100">
            <div className="accountDetail_usd accountDetail_item fw-bold">USD</div>
            <div className="accountDetail_price accountDetail_item fw-bold">
              <span>${formatAmount(amount)}</span>
            </div>
          </div>
          {bankName?.length > 0 ? <div className="linkAccount">
            {bankName.map((bank, index) => (
              <div
                key={index}
                className="linkAccount_bankList d-flex align-items-center justify-content-between"
              >
                <div className="form-check d-flex align-items-center">
                  <input
                    className="form-check-input me-3"
                    type="radio"
                    name="flexRadioDefault"
                    id={`flexRadioDefault${index}`}
                    checked={bankName[index]?.bankName === selectedBank?.bankName}
                    onChange={(e) => handleBankSelection(e, bank)}
                  />
                  <label className="form-check-label" htmlFor={`flexRadioDefault${index}`}>
                    <div className="name text-uppercase">{bank.bankName}</div>
                    <div className="details">
                      {bank.bankType} - **** {bank.lastFourDigits}
                    </div>
                  </label>
                </div>
                <em className="bi bi-bank" />
              </div>
            ))}
            {bankName.length > 0 ? (
              <div className="btnAction mt-4">
                <button
                  className="btn btn-primary rounded-pill btn-lg w-100"
                  disabled={!selectedBank || selectedBank?.loading}
                  onClick={handleProceed}
                >
                  {selectedBank?.loading ? (
                    <Spin
                      spinning={selectedBank?.loading}
                      className="h-100 w-100 align-items-center d-flex justify-content-center"
                    ></Spin>
                  ) : (
                    'Proceed'
                  )}
                </button>
              </div>
            ) : (
              <>
                <div className="d-flex justify-content-center">
                  <span></span>
                </div>
                {/* </BlueButton> */}
              </>
            )}
          </div> : <h2 className="accountDetail-msg"><FormattedMessage id="invoice.no.bank" /></h2>}
        </div>
      </Spin>
    </>
  );
};

export default CompanyIndividualPlaidPaymentComponent;
